import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-800 py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="mb-8" data-id="element-130">
          <h3 className="text-2xl font-bold text-gold-400 mb-2" data-id="element-131">
            🌎 MUNDORECURSOS™
          </h3>
          <p className="text-white font-medium mt-4 italic" data-id="element-132">
            "Porque alimentar bien a tu familia no debería costarte todos los
            domingos del año."
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-blue-200/70" data-id="element-133">
          <a href="mailto:soportemundorecursos@gmail.com" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-134">
            <Mail className="w-5 h-5" data-id="element-135" /> soportemundorecursos@gmail.com
          </a>
          <a href="https://www.instagram.com/mundorecursos.online/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-136">
            <Instagram className="w-5 h-5" data-id="element-137" /> @mundorecursos.online
          </a>
          <a href="https://www.mundorecursos.store" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-138">
            <Globe className="w-5 h-5" data-id="element-139" /> www.mundorecursos.store
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 text-sm text-navy-500" data-id="element-140">
          <p className="mb-4" data-id="element-141">
            © MundoRecursos™ 2024 — Todos los derechos reservados.
          </p>
          <p className="text-blue-200/30 italic" data-id="element-142">
            "La familia que planifica, llega a fin de mes." 🌎
          </p>
        </div>
      </div>
    </footer>;
}